<template>
	<div class="users-page">
		<div class="table-heading">
			<h2 />
			<UserTableSearch
				@onSearchChange="handleSearchChange"
			/>
		</div>
		<v-client-table
			v-if="!preloaderVisibility"
			v-model="userList"
			:columns="columnsOptions"
			:options="options"
		>
			<div slot="h__fullName">Name</div>
			<div slot="h__userRole">Type</div>
			<router-link
				slot="edit"
				slot-scope="users"
				class="nav-item"
				:to="`/user/edit/${users.row.userId}`"
			>
				Edit
			</router-link>
		</v-client-table>
    <div
        v-if="preloaderVisibility"
        class="table-skeleton" />
		<PreloaderComponent v-if="preloaderVisibility"/>
		<Paginate
			v-if="pageCount !== 1 && userList.length"
			v-model="currentPage"
			:page-count="pageCount"
			:container-class="'pagination'"
			:page-class="'page-item'"
			:prev-text="'<'"
			:next-text="'>'"
			:prev-class="'page-item'"
			:next-class="'page-item'"
			:click-handler="paginationHandler"/>
	</div>
</template>

<script>
import Paginate from 'vuejs-paginate'

import CheckAPI from '@/api'
import {tableOptions, columns} from '@/components/userTable/config'
import UserTableSearch from '@/components/userTable/UserTableSearch'
import PreloaderComponent from '@/components/common/PreloaderComponent'

export default {
	name: "usersTable",
	components: {
		Paginate,
		UserTableSearch,
		PreloaderComponent
	},
	data() {
		return {
			options: tableOptions,
			modalView: false,
			deleteUserId: 0,
			userList: [],
			columnsOptions: columns,
			pageCount: 0,

			total: 0,
			searchField: '',
			currentPage: 1,
			size: 30,

			preloaderVisibility: true
		}
	},
	mounted() {
		this.setInitialPage();
	},
	methods: {
		setPage() {
			this.currentPage = parseInt(this.$route.query.page || 1);
			this.$router.push({path: '/', query: { page: parseInt(this.$route.query.page || 1) }})
			this.fetchUsers();
		},
		setInitialPage() {
			if (this.$route.query.page !== 1) {
				this.currentPage = parseInt(this.$route.query.page || 1);
				this.$router.push({path: '/', query: { page: parseInt(this.$route.query.page || 1) }})
				this.fetchUsers();
			}
		},
		async fetchUsers() {
			this.currentPage = parseInt(this.$route.query.page) || 1
			const response = await CheckAPI.getUsers({
				page: this.currentPage - 1,
				size: this.size,
				searchField: this.searchField
			});
			this.total = response.data.data.total_items
			this.pageCount = response.data.data.total_pages
			this.preloaderVisibility = false
			const transformedData = response.data.data.items.map(singleUser => ({
				...singleUser,
				fullName: singleUser.firstName + ' ' + singleUser.lastName,
				userRole: singleUser.userRole.toLowerCase()[0].toUpperCase() + singleUser.userRole.toLowerCase().substring(1)
			}));
			this.userList = transformedData
		},
		handleSearchChange(e) {
			if (this.$route.query.page !== 1)
				this.$router.push({path: '/', query: { page: 1 }})
			this.preloaderVisibility = true
			this.searchField = e;
			this.fetchUsers()
		},
		paginationHandler(e) {
			this.currentPage = e;
			this.$router.push({path: '/', query: { page: e }})
			this.preloaderVisibility = true
		}
	},
	watch: {
		'$route.query.page': {
			deep: true,
			handler() {
				this.preloaderVisibility = true;
				this.fetchUsers();
			}
		}
	}
}
</script>

<style lang="scss">

.table-heading {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.pagination {
	list-style: none;
	display: flex;
	justify-content: center;
	padding: 0;

	.page-item {
		transition: .4s ease all;
		background-color: #34558b;

		a {
			display: inline-block;
			padding: 6px 10px;
			color: white;
			border-radius: 6px;
		}

		&.active {
			background-color: #35495e;
		}

		&.disabled {
			a {
				color: #35495e;
				cursor: not-allowed;
			}

			&:hover {
				background-color: #fff;
			}

			background-color: #fff;
		}

		margin: 3px;
		border-radius: 6px;

		&:hover {
			a {
				color: white;
			}

			background-color: #35495e;
		}
	}
}

.table-skeleton {
  height: 492px;
}

</style>
